<template>
  <div class="wrap vertical-spacing">
    <Loader :loading="isCreateCartLoading" :text="$t('Loading Cart...')">
      <div class="container-fluid">
        <div class="row">
          <div class="cart col-xs-12 col-md-8">
            <Loader :loading="isCartLoading" :text="$t('Updating Cart...')">
              <div v-if="cart.length">
                <CollectedProduct
                  v-for="product in cart"
                  :key="product.Product.Id"
                  :product="product"
                  :isPreview="isPreview"
                />
              </div>
              <div v-else>
                <SfHeading :title="$t('Your shopping cart is empty.')" :level="2" />
              </div>
            </Loader>
          </div>
          <div class="total-items col-xs-12 col-md-4">
            <div>
              <template v-if="!isPreview && showTotals">
                <Loader :loading="isCartLoading" :text="$t('Updating Cart...')">
                  <Totals class="m-b-20" />
                </Loader>
              </template>
              <SfButton class="sf-button--text m-b-10" @click="clearCart">
                {{ $t("Clear Cart") }}
              </SfButton>
              <SfButton
                :disabled="!isCheckoutAllowed"
                @click="$router.replace('/checkout')"
                class="sf-button--full-width color-primary"
              >
                {{ isCheckoutAllowed ? $t("Go to Checkout") : $t("Loading Cart...") }}
              </SfButton>
              <SfButton
                @click="$router.replace('/offer')"
                class="m-t-10 sf-button--full-width color-primary"
              >
                {{ $t("Create Offer") }}
              </SfButton>
            </div>
            <QuickCart class="m-t-25" />
            <CsvCart class="m-t-25" />
            <SaveCart class="m-t-25" v-if="cart.length" />
          </div>
        </div>
      </div>
    </Loader>
  </div>
</template>
<script>
import { SfButton, SfHeading } from '@storefront-ui/vue';
import { Loader } from '@/modules/core';
import { user } from '@/modules/user';
import CollectedProduct from '../components/CollectedProduct.vue';
import cart from '../mixins/cart';
import Totals from '../components/Totals.vue';
import QuickCart from '../components/cart/QuickCart.vue';
import CsvCart from '../components/cart/CsvCart.vue';
import SaveCart from '../components/cart/SaveCart.vue';

export default {
  name: 'Cart',
  mixins: [cart, user],
  components: {
    SfButton,
    SfHeading,
    CollectedProduct,
    Loader,
    Totals,
    QuickCart,
    SaveCart,
    CsvCart,
  },
  created() {
    const fetchCart = this.isPreview ? this.fetchSimpleCart : this.fetchCart;

    fetchCart()
      .then(() => this.fetchCurrentCustomer())
      .then(() => this.fetchTotals({
        ShippingAddressId: this.customer.Addresses[0]?.Id || '',
        BillingAddressId: this.customer.Addresses[0]?.Id || '',
      }))
      .finally(() => {
        this.isCreateCartLoading = false;
      });
  },
  data() {
    return {
      isCreateCartLoading: true,
      isPreview: true,
    };
  },
  methods: {
    removeHandler(product) {
      const products = [...this.products];
      this.products = products.filter((element) => element.id !== product.id);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";
@import "src/scss/_breakpoint.scss";

.fz-sidebar__cart-items {
  margin: var(--spacer-sm) 0;
  & > span {
    font-weight: var(--font-medium);
  }
}

@include flexbox-mobile {
  .cart {
    margin-bottom: var(--spacer-sm);
  }
}

.sf-collected-product {
  --collected-product-width: 100%;
}
</style>
